import React from "react";
import "./banner.scss";

const Banner = ({ firstName, loanAmount, bannerDetails }) => {
  return (
    <section className="combo-app-banner">
      <nav className="navbar navbar-light m-0">
        <a className="navbar-brand">
          <span className="bcus-logo"/>
        </a>
        <span className="bcus-text-dark-cyan">{bannerDetails.partnerMessage}
          <span className={bannerDetails.logoClassName}> </span>
        </span>
      </nav>
    </section>
  );
};

export default Banner;
